import React from "react";
import { Trash2 } from "lucide-react";

export const inputCls = "w-full px-3 py-2 rounded-lg border focus:outline-none focus:border-blue-500 text-sm";

export function QuickList({ items, render, onDelete, empty, testId }) {
  if (!items.length) return <div className="text-xs text-slate-500 py-3" data-testid={`${testId}-empty`}>{empty}</div>;
  return (
    <ul className="divide-y divide-slate-800/70 border border-slate-800 rounded-lg max-h-44 overflow-y-auto mb-3" data-testid={testId}>
      {items.map((it) => (
        <li key={it.id} className="flex items-center justify-between gap-2 px-3 py-2 text-sm" data-testid={`${testId}-item-${it.id}`}>
          <div className="min-w-0 truncate text-slate-200">{render(it)}</div>
          <button type="button" onClick={() => onDelete(it)} data-testid={`${testId}-delete-${it.id}`} className="text-slate-500 hover:text-rose-400 shrink-0"><Trash2 size={13} /></button>
        </li>
      ))}
    </ul>
  );
}
